import { Component, Input, OnChanges, OnInit } from '@angular/core';
import * as debug from 'debug';
import { SocketService } from '@app/core/socket.service';
import { ReplyAbstractComponent } from '@app/shared/components/reply/reply-abstract.component';
import { DomSanitizer } from '@angular/platform-browser';
import { BalanceHistoryService } from '@app/core/account/balance-history.service';
// import { DiceService } from '@app/games/dice/services/dice.service';
const log = debug('edg:reply-dice');
const MersenneTwister = require('mersennetwister');

@Component({
  selector: 'app-reply-dice',
  template: `
    <div class="reply-loader" *ngIf="_loading || !data">
      <i class="fal fa-spinner fa-spin" [hidden]="_error"></i>
      <i class="fal fa-exclamation-triangle" [hidden]="!_error"></i>
    </div>
    <ng-container *ngIf="!_loading && data">
      <div class="verify-seed-dice-numbers">
        <div class="dice-numbers">0</div>
        <div class="dice-numbers">25</div>
        <div class="dice-numbers">50</div>
        <div class="dice-numbers">75</div>
        <div class="dice-numbers">100</div>
      </div>

      <div class="dice-slider-wrap">
        <div class="result-wrapper">
          <div
            class="slider-result"
            *ngIf="data.result != null"
            [ngClass]="{ red: data.result > this.data.slider }"
            [ngStyle]="{ left: data.result + '%' }"
          >
            {{ data.result.toFixed(2) }}
          </div>
        </div>

        <input
          title="Slider"
          class="dice-slider red"
          type="range"
          min="1"
          max="99"
          step="1"
          [value]="data.slider"
          (ngModelChange)="changeSlider($event)"
          [style.background]="sliderStyleBg"
          disabled
        />
      </div>
    </ng-container>
  `,
  styleUrls: ['./reply-dice.component.scss'],
})
export class ReplyDiceComponent extends ReplyAbstractComponent implements OnChanges {
  data: any = null;
  sliderStyleBg: any;

  constructor(
    protected socket: SocketService,
    protected balanceHistory: BalanceHistoryService,
    private sanitizer: DomSanitizer
  ) /*private diceService: DiceService*/ {
    super(socket, balanceHistory);
  }

  protected initialize(data: any) {
    if (['dice', 'spooky-dice', 'ice-dice'].indexOf(data.game) === -1) {
      this._error = true;
      return;
    }
    this.data = data.gameData;
    this.data.result = Number((this.data.result / 10).toFixed(1));
    log(this.data);

    this.sliderStyleBg = this.sanitizer.bypassSecurityTrustStyle(
      '-webkit-gradient(linear, left top, right top, ' +
        'color-stop(' +
        this.data.slider / 100 +
        ', ' +
        (this.data.range ? '#3ecf8e' : '#ff6060') +
        '), ' +
        'color-stop(' +
        this.data.slider / 100 +
        ', ' +
        (!this.data.range ? '#3ecf8e' : '#ff6060') +
        ')' +
        ')'
    );
    this._loading = false;
  }

  protected generateGame() {
    const data = {
      gameData: {
        range: true,
        slider: 50,
        result: this.generateLuckyNr(this.serverSeed, this.playerSeed),
      },
      win: false,
      game: 'dice',
    };
    data.win = data.gameData.result / 10 <= 50;

    this.initialize(data);
  }

  generateLuckyNr(serverSeed: string, clientSeed: string): number {
    if (!serverSeed || !clientSeed) {
      return null;
    }
    clientSeed = clientSeed.replace('0x', '');
    serverSeed = serverSeed.replace('0x', '');
    const clSeedSplitted = clientSeed.match(/.{1,6}/g);
    const srvSeedSplitted = serverSeed.match(/.{1,6}/g);
    const seedsCombined = clSeedSplitted.concat(srvSeedSplitted);
    const seedsCominedNum = [];
    for (let i = 0; i < seedsCombined.length; i++) {
      seedsCominedNum[i] = parseInt(seedsCombined[i], 16);
    }

    const mt = new MersenneTwister();
    mt.seedArray(seedsCominedNum);
    return mt.int() % 1001;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-dice.component.ts